import ColumnWidgetEditor
  from '@components/Widgets/ColumnWidget/ColumnWidgetEditor/ColumnWidgetEditor.vue'
import ImageColumnWidgetEditor
  from '@components/Widgets/ImageColumnWidget/ImageColumnWidgetEditor/ImageColumnWidgetEditor.vue'
import FortuneWheelWidgetEditor
  from '@components/Widgets/FortuneWheelWidget/FortuneWheelWidgetEditor/FortuneWheelWidgetEditor.vue'
import ContentItemsMenu from '@components/menues/ContentItems/ContentItems.vue'
import ThemeMenu from '@components/menues/ThemeEditor/ThemeEditor.vue'
import { mapActions, mapGetters } from 'vuex'
import { type } from '@meta/widget/options'

export default {
  name: 'EditorTabsContainer',
  components: {
    'column-widget-editor-component': ColumnWidgetEditor,
    'image-column-widget-editor-component': ImageColumnWidgetEditor,
    'fortune-wheel-widget-editor-component': FortuneWheelWidgetEditor,
    'content-items-menu': ContentItemsMenu,
    'theme-menu': ThemeMenu,
  },
  computed: {
    targetContentItemID() {
      return this.$store.state.campaign.contentItem.targetContentItemID
    },
    targetStepID() {
      return this.$store.state.campaign.step.targetStepID
    },
    disableSettings() {
      // wheel edge case (wheel content item is in settings)
      if (this.targetWidget.type === type.FORTUNE_WHEEL) {
        if (this.targetContentItemID === this.targetWidget.settings.wheel.id) {
          return false
        }
      }

      if (this.targetWidget.type === type.IMAGE_COLUMN) {
        if (this.targetContentItemID === this.targetWidget.settings.sideImage.id) {
          return false
        }
      }

      return !this.hasSettingsByTypeName(
        this.targetWidget.steps[this.targetStepID].contentItems[this.targetContentItemID].type)
    },
    ...mapGetters('campaign/widget', ['targetWidget']),
    ...mapGetters('campaign/contentItem', ['hasSettingsByTypeName']),
  },
  data() {
    return {
      activeContentItemMenuName: 'content',
      activeMenuName: 'contentItems',
    }
  },
  watch: {
    targetContentItemID: function () {
      // Resets Tabs on every contentItem change
      this.activeContentItemMenuName = 'content'
      this.activeMenuName = 'contentItems'
    },
  },
  methods: {
    ...mapActions('editor', ['setVisibleMenu']),
  },
}
